import { useNavigation } from '@react-navigation/native';
import React, {
    useEffect,
    useMemo,
    useState
} from 'react';
import {
    useDispatch,
    useSelector
} from 'react-redux';

import { setFormValue } from '../../../actions/forms';
import {
    Button,
    Card,
    Icon,
    TextHighliter,
    View
} from '../../../common';
import {
    inAppUpdaterStyles,
    inAppUpdaterStyles as styles
} from '../../../common/InAppUpdater';
import {
    getIsAuthenticated,
    getIsEmailUnconfirmed,
    getUserInfo
} from '../../../selectors';
import { getFormValues } from '../../../selectors/forms';

export const DISABLE_EMAIL_REMINDER_KEY = 'disableEmailReminder';

export const EmailReminder = () => {
    const isAuthenticated = useSelector(getIsAuthenticated);
    const formValues = useSelector(getFormValues);
    const dispatch = useDispatch();
    const navigation = useNavigation();

    const info = useSelector(getUserInfo);
    const isEmailUnconfirmed = useSelector(getIsEmailUnconfirmed);
    const [ isWindowDisable, setIsWindowDisable ] = useState(true);

    const closeWindowHandler = () => {
        dispatch(setFormValue(DISABLE_EMAIL_REMINDER_KEY, true));
    };

    useEffect(() => {
        setIsWindowDisable(formValues?.[DISABLE_EMAIL_REMINDER_KEY]);
    }, [ formValues ]);

    const email = useMemo(() => {
        return info?.emails?.find(({ usage }) => usage === 'PRIMARY')?.address;
    }, [ info?.emails ]);

    const emailUnconfirmed = useMemo(() => {
        return info?.emails?.find?.(({ confirmed } = {}) => !confirmed)?.address;
    }, [ info?.emails ]);

    const emailMessage = useMemo(() => {
        return (
            <TextHighliter
                style={inAppUpdaterStyles.stdText}
                highlightStyle={{
                    fontFamily: 'Helvetica',
                    fontWeight: 'bold',
                }}
                keyword={emailUnconfirmed ?? email}
                numberOfLines={0}
                value={Object.R('reminder.confirmEmail', { email: emailUnconfirmed ?? email })}
                backgroundColor={'white'}
            />
        );
    }, [ email, emailUnconfirmed ]);

    return isEmailUnconfirmed && !isWindowDisable && isAuthenticated && !!(emailUnconfirmed ?? email) ? (
        <>
            <Card containerStyle={[ styles.wrapper, { position: 'relative' } ]}>
                <View style={styles.lineWrapper}>
                    <Button
                        action={closeWindowHandler}
                        styles={[
                            styles.closeButton,
                            {
                                position: 'absolute',
                                right: -14,
                                top: -14,
                            },
                        ]}
                    >
                        <Icon
                            name="cross"
                            color="#787878"
                            style={styles.closeIcon}
                        />
                    </Button>
                </View>
                {emailMessage}
                <Button
                    transparent
                    title={Object.R('reminder.confirmEmailButton')}
                    titleStyles={{ color: '#5C85DD' }}
                    action={() => {
                        navigation.navigate('Account');
                    }}
                />
                <View/>
            </Card>
        </>
    ) : null;
};
